import { render } from "./Trend.vue?vue&type=template&id=77ae14ae&scoped=true&ts=true"
import script from "./Trend.vue?vue&type=script&lang=ts"
export * from "./Trend.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ae14ae"]])

export default __exports__